import React, { Fragment } from 'react';

// Components

import SummaryItem from '../SummaryItem';



const DisabilityInfo = props => {

    const {
        applyingForCoverageIndicator,
        blindOrDisabled,
        idx,
        longTermCare
    } = props;

    if(!applyingForCoverageIndicator) {
        return null;
    }

    return (
        <Fragment>
            <SummaryItem
                textCode = 'common.disability_or_mental'
                value = { blindOrDisabled }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].blindOrDisabled`
                        ]
                    ]
                }
            />
            <SummaryItem
                textCode = 'common.help_with_activities'
                value = { longTermCare }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].longTermCare`
                        ]
                    ]
                }
            />
        </Fragment>
    );
};

export default DisabilityInfo;